import { useRoundScoreSummaryState } from '../../Context/RoundScoreSummary.context';
import { useProcessedHandicaps } from './Hooks/useProcessedHandicaps';
import { useProcessedValue } from './Hooks/useProcessedValue';

export type TPartials = Array<{ name: string; from: number; to: number }>;

interface ISetClubIdAugmentedArgs {
  end?: number;
  partials?: TPartials;
  start?: number;
}

type processValuesNames =
  | 'processedAppliedHandicaps'
  | 'processedGross'
  | 'processedHandicaps'
  | 'processedNets'
  | 'processedOriginals'
  | 'processedPars'
  | 'processedStablefords';

export type IProcessScoresValues = (
  args: ISetClubIdAugmentedArgs
) => Record<processValuesNames, string[]> & { grossWithAppliedHandicap: string[][] };

export const useGetProcessedValues: IProcessScoresValues = args => {
  const { end = 18, partials = [], start = 0 } = args;

  const {
    appliedHandicaps,
    handicaps,
    pars,
    gross,
    nets,
    stablefords,
    originals
  } = useRoundScoreSummaryState();

  const processedPars = useProcessedValue(pars, start, end, partials);
  const processedOriginals = useProcessedValue(originals, start, end, partials);
  const processedGross = useProcessedValue(gross, start, end, partials);
  const processedStablefords = useProcessedValue(stablefords, start, end, partials);
  const processedNets = useProcessedValue(nets, start, end, partials);

  const processedHandicaps = useProcessedHandicaps(handicaps, start, end, partials);
  const processedAppliedHandicaps = useProcessedHandicaps(appliedHandicaps, start, end, partials);

  const grossWithAppliedHandicap = processedGross.map((k, i) => [k, appliedHandicaps[i]]);

  return {
    grossWithAppliedHandicap,
    processedAppliedHandicaps,
    processedGross,
    processedHandicaps,
    processedNets,
    processedOriginals,
    processedPars,
    processedStablefords
  };
};
